<template>
  <div id="app" v-cloak>
     <router-view/>
  </div>
</template>

<script>
export default {
  created() {
    this.axios.get("/student/base/themeConfig").then(res => {
      try {
        let config = JSON.parse(res.data.config)
        this.$store.commit('setConfig', config)
        // console.log(config);
        let url = window.location.href;
        // console.log('---url:',url);
        if (url.indexOf('/main') > -1 || url.indexOf('/poster') > -1|| url.indexOf('/thesis-edit') > -1|| url.indexOf('/db-waiting-area') > -1|| url.indexOf('/online-defense-room') > -1) {
          return
        } else {
          if (config.zhuti == "newyear") {
            this.$router.push({ name: "newyear" })
            return
          } else if (config.zhuti == "filter") {
            document.body.style.filter = 'grayscale(100%)'
          }
          this.$router.push({ name: "Login" })
        }
      } catch (error) {
        console.log('error:',error);
      }
    })

  }
}
</script>

<style scoped>
#app {
 background: #F8F8F8;
 overflow: auto;
}
</style>
